import { useEffect, useState } from 'react'

export function useBrowserHeight() {
  const [height, setHeight] = useState<number>(0)

  useEffect(() => {
    const outSideTableHeight = 60 + 112 + 55 + 32 * 2.5

    if (typeof window !== 'undefined') {
      setHeight(window.innerHeight - outSideTableHeight)

      window.addEventListener('resize', () => {
        setHeight(window.innerHeight - outSideTableHeight)
      })
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', () => {})
      }
    }
  }, [])

  return height
}
